import React, { useState, useEffect } from "react";

const Sectorsplit = ({ data }) => {
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const pageSize = 5; // Number of items per page

  // Helper function to generate a random color
  const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  // Add random color to each sector in the data
  const dataWithColors = data.map((item) => ({
    ...item,
    color: item.color || getRandomColor(), // Assign random color if not already present
  }));

  // Paginated data
  const paginatedData = dataWithColors.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  // Calculate total number of pages
  const totalPages = Math.ceil(dataWithColors.length / pageSize);

  // Handle page change
  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div
      style={{
        flex: 1,
        padding: "20px",
        borderRadius: "8px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
      }}
    >
      <h3 style={{ marginBottom: "20px" }}>Sector Allocation</h3>
      {paginatedData.map((item, index) => (
        <div key={index} style={{ marginBottom: "15px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "5px",
            }}
          >
            <span style={{ fontSize: "14px", color: "#444" }}>
              {item.sector}
            </span>
            <span
              style={{ fontSize: "14px", fontWeight: "bold", color: "#444" }}
            >
              {item.percentage}%
            </span>
          </div>
          <div
            style={{
              height: "8px",
              backgroundColor: "#e0e0e0",
              borderRadius: "4px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${item.percentage}%`, // Bar length based on percentage
                backgroundColor: item.color, // Use the random color
                height: "100%",
                transition: "width 0.3s ease",
              }}
            ></div>
          </div>
        </div>
      ))}
      {/* Pagination Controls */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <button
          onClick={goToPreviousPage}
          disabled={currentPage === 1}
          style={{
            padding: "5px 10px",
            backgroundColor: currentPage === 1 ? "#e0e0e0" : "#4285F4",
            color: currentPage === 1 ? "#888" : "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: currentPage === 1 ? "not-allowed" : "pointer",
            fontSize: "16px",
          }}
        >
          {"<"}
        </button>
        <span style={{ fontSize: "14px", color: "#444" }}>
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={goToNextPage}
          disabled={currentPage === totalPages}
          style={{
            padding: "5px 10px",
            backgroundColor: currentPage === totalPages ? "#e0e0e0" : "#4285F4",
            color: currentPage === totalPages ? "#888" : "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            fontSize: "16px",
          }}
        >
          {">"}
        </button>
      </div>
    </div>
  );
};

export default Sectorsplit;
